import type { Theme } from './ir.js';

/** Backfill the paint-token families (ADR 0014) on a theme that predates them, so a legacy persisted
 *  authoring doc or app-default theme reads without crashing on `theme.radii` and friends.
 *
 *  `themeSchema` already defaults these on any zod-parse path; this covers the paths that receive a
 *  RAW theme object (the app-theme query, an already-open draft) and never parse it. Additive and
 *  idempotent — a theme that already has the families is returned unchanged in shape. */
export function normalizeTheme(theme: Theme): Theme {
  // The input may be a legacy object literally missing these keys, so read through a loose view.
  const t = theme as unknown as Record<string, unknown>;
  return {
    ...theme,
    radii: (t.radii as Theme['radii']) ?? {},
    elevations: (t.elevations as Theme['elevations']) ?? {},
    gradients: (t.gradients as Theme['gradients']) ?? {},
  };
}
